import { publicEnvConfig } from 'helpers/env';
import { useEffect } from 'react';

const createMiniProfilerScript = () => {
	// NOTE: attach dynamic script and localhost hack to fetch rack-mini-profiler results
	//  REF: https://github.com/MiniProfiler/rack-mini-profiler#using-in-spa-applications
	const script = document.createElement('script');
	const attrs = [
		['data-css-url', '/mini-profiler-resources/includes.css?v=2.3.2'],
		['data-version', '2.3.2'],
		['data-path', '/mini-profiler-resources/'],
		['data-current-id', ''],
		['data-ids', ''],
		['data-horizontal-position', 'left'],
		['data-vertical-position', 'top'],
		['data-trivial', 'false'],
		['data-children', 'false'],
		['data-max-traces', '100'],
		['data-controls', 'true'],
		['data-total-sql-count', 'false'],
		['data-authorized', 'true'],
		['data-toggle-shortcut', 'alt+p'],
		['data-start-hidden', 'false'],
		['data-collapse-results', 'true'],
		['data-html-container', 'body'],
		['data-hidden-custom-fields', ''],
	];

	script.async = true;
	script.src = '/mini-profiler-resources/includes.js?v=2.3.2';
	script.type = 'text/javascript';
	script.id = 'mini-profiler';
	// Configure profiler attributes
	for (const [key, value] of attrs) {
		script.setAttribute(key, value);
	}

	document.head.appendChild(script);

	return script.id;
};

const fetchMiniProfilerResults = (req) => {
	const headers = req.getAllResponseHeaders();

	// Grab rack-mini-profiler ids and use public fetchResultsExposed function to fetch results
	if (headers.includes('x-miniprofiler-ids')) {
		const ids = (req.getResponseHeader('X-Miniprofiler-Ids') || '').split(',');
		if (
			Array.isArray(ids) &&
			ids.length > 0 &&
			window.MiniProfiler &&
			typeof window.MiniProfiler.fetchResultsExposed === 'function'
		) {
			window.MiniProfiler.fetchResultsExposed(ids);
		}
	}
};

export const useRackMiniProfiler = (isLoggedIn) => {
	useEffect(() => {
		// Rack MiniProfiler is only optionally enabled in non-production environment.
		//  NOTE: Use RELEASE_STATE var instead of ENV/NODE_ENV to determine if we're running in non-production
		//      environment since some of our staging/ondemand environments are running in production mode but we only
		//      want to enable mini-profiler for specific environments where var is built.
		if (isLoggedIn && publicEnvConfig.RELEASE_STAGE !== 'production' && publicEnvConfig.ENABLE_RACK_MINIPROFILER) {
			const scriptId = createMiniProfilerScript();

			// NOTE: this is a hack to intercept XMLHttpRequest and fetch rack-mini-profiler results for
			//  localhost/diff-origin for webapp and railsapp
			let originalSend = undefined;
			if (publicEnvConfig.BASE_URL !== publicEnvConfig.RESTURL_BASE) {
				originalSend = XMLHttpRequest.prototype.send;

				XMLHttpRequest.prototype.send = function (...args) {
					this.addEventListener('load', function () {
						fetchMiniProfilerResults(this);
					});
					return originalSend.apply(this, args);
				};
			}
			return () => {
				originalSend && (XMLHttpRequest.prototype.send = originalSend);
				document.getElementById(scriptId)?.remove();
			};
		}
	}, [isLoggedIn]);
};
